// Google Analytics configuration
// Replace 'G-XXXXXXXXXX' with your actual Google Analytics Measurement ID
export const GA_MEASUREMENT_ID = 'G-F7DMJTKW81';

// Set to true to enable Google Analytics in production
export const ENABLE_ANALYTICS = true;